import { render, staticRenderFns } from "./progress.vue?vue&type=template&id=b4067f7c&scoped=true&"
import script from "./progress.vue?vue&type=script&lang=js&"
export * from "./progress.vue?vue&type=script&lang=js&"
import style0 from "./progress.vue?vue&type=style&index=0&id=b4067f7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4067f7c",
  null
  
)

export default component.exports